import { Component, HostBinding, ViewEncapsulation } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
  selector: 'form-radio-field',
  standalone: false,
  encapsulation: ViewEncapsulation.None,
  styles: [
    `
      .form-radio-field {
        display: flex;
        flex-direction: column;

        .radio-label {
          pointer-events: none;
          top: var(--p-iftalabel-top);
          transition-property: all;
          transition-timing-function: ease;
          line-height: 1;
          font-size: var(--p-iftalabel-font-size);
          font-weight: var(--p-iftalabel-font-weight);
          inset-inline-start: var(--p-iftalabel-position-x);
          color: var(--p-iftalabel-color);
          transition-duration: var(--p-iftalabel-transition-duration);
          margin-bottom: 0.5rem;
        }
      }
    `,
  ],
  template: `
    <div *ngIf="field.props.label" class="radio-label">
      {{
        field.props['translate']
          ? (field.props.label | translate)
          : field.props.label
      }}
    </div>
    <div *ngFor="let category of $any(field.props.options)" class="mr-4">
      <p-radiobutton
        [inputId]="field.id + '-' + category.id"
        [name]="field.id"
        [formControl]="formControl"
        [value]="category.id"
      />
      <label [htmlFor]="field.id + '-' + category.id" class="ml-2">{{
        field.props['translate'] ? (category.name | translate) : category.name
      }}</label>
    </div>

    <!--<p-radiobutton


        [options]="$any(field.props.options)"
        [formControl]="formControl"
        [optionValue]="'id'"
        [formlyAttributes]="field"
        class="w-full flex"
        optionLabel="name"
      /> -->
    <!-- <p-radiobutton [inputId]="category.key"name="category" [value]="category" [(ngModel)]="selectedCategory" />-->

    <!--<label *ngIf="field.props.label" [htmlFor]="field.id">{{
        field.props.label
      }}</label> -->
  `,
})
export class FormRadioFieldType extends FieldType<FieldTypeConfig> {
  @HostBinding('class')
  readonly cssClass = 'form-radio-field';
}
